const downloadPreviewLinks = document.querySelectorAll('a.download-preview-link');

downloadPreviewLinks.forEach(link => {
    link.addEventListener('click', e => {
        e.preventDefault();
        let fileId = link.dataset.fileId;

        // if no fileId is present, try to search for a file-XXX class
        if (!fileId) {
            const classes = link.classList;
            for (let i = 0; i < classes.length; i++) {
                const classList = classes[i];
                if (classList.includes('file-')) {
                    fileId = classList.replace('file-', '');
                    break;
                }
            }
        }

        showDownloadPreview(link.href, fileId, link.textContent);
    });
});

const showDownloadPreview = (url, id, title) => {
    const dialog = document.createElement('dialog');
    const previewUrl = `https://portal.indamed.de/?file_preview=${id}`;

    fetch(ajaxurl + '?action=indamed_favorite_button&type=download&id=' + id)
        .then(response => response.text())
        .then(html => {
            
            dialog.classList.add('download-preview-dialog');
            dialog.innerHTML = `
                <div class="download-preview-header">
                    <h3>${ title }</h3>
                    <div>
                        ${html}
                        <a href="${ url }" download class="button download-btn">Herunterladen</a>
                        <button class="button close-btn outline">Schließen</button>
                    </div>
                </div>
                <div class="download-preview-dialog-content">
                    <iframe src="${previewUrl}" frameborder="0"></iframe>
                </div>
            `;
            dialog.querySelector('.close-btn').addEventListener('click', () => dialog.close());

            document.body.appendChild(dialog);

            dialog.showModal();

            dialog.addEventListener('close', () => {
                console.log('closed');
                dialog.remove();
            });

        });

    
}